import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { GameOption, GameType } from '@app/@shared/models/game.model';
import { FavoriteComponent } from '../favorite/favorite.component';
import { MelateService } from '@app/@shared/services/melate.service';
import { ModalController } from '@ionic/angular';
import { SorteoType } from '@app/@shared/models/sorteo.model';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { ChispazoService } from '@app/@shared/services/chispazo.service';
import { TrisService } from '@app/@shared/services/tris.service';
import { GanaGatoService } from '@app/@shared/services/gana-gato.service';
import { ProtouchService } from '@app/@shared/services/protouch.service';
import { PronoSportsService } from '@app/@shared/services/prono-sports.service';
import { RecommendationComponent } from '../recommendation/recommendation.component';
import { ProgolMSRecommendationResult, ProtouchRecommendationResult } from '@app/@shared/models/quiniela.model';
import { ProgolService } from '@app/@shared/services/progol.service';
@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrl: './options.component.scss',
})
export class OptionsComponent {
  @Input() options: GameOption[] = [];
  @Input() text = '¿Cómo quieres jugar?';
  @Input() selected = 'manual';
  @Input() gameType!: GameType;
  @Input() isMediaSemana!: boolean;

  @Input() melateS?: MelateService;
  @Input() isRetro = false;

  @Input() sorteoType?: SorteoType;
  @Input() sorteoS?: SorteoService;

  @Input() chispazoS?: ChispazoService;
  @Input() trisS?: TrisService;
  @Input() ganaGatoS?: GanaGatoService;

  @Input() progolS?: ProgolService;
  @Input() protouchS?: ProtouchService;
  @Input() pronoSportsS?: PronoSportsService;
  @Output() changeOption = new EventEmitter<GameOption>();
  @Output() applyRecommendedNumbers = new EventEmitter<number[]>();
  @Output() applyRecommendedProtouch = new EventEmitter<ProtouchRecommendationResult>();
  @Output() applyRecommendedProgolMS = new EventEmitter<ProgolMSRecommendationResult>();
  @Output() applyRecommendedProgolRev = new EventEmitter<ProgolMSRecommendationResult>();

  @Output() applyFavoriteTickets = new EventEmitter<any>();
  private readonly nonSelectable: string[] = ['automatic', 'recommended', 'favorite'];
  constructor(private modalCtrl: ModalController) {}

  goToOption(option: GameOption, ev: Event) {
    const { path } = option;

    switch (path) {
      case 'favorite':
        if (this.gameType === 'sorteo') {
          this.changeOption.emit(option);
          this.openPopoverRecommendation(ev);
        } else {
          this.openPopoverRecommendation(ev);
        }
        break;

      case 'recommended':
        if (this.gameType === 'sorteo') {
          this.changeOption.emit(option);
          this.openPopoverRecommendation(ev);
        } else {
          this.openPopoverRecommendation(ev);
        }
        break;

      case 'automatic':
        this.changeOption.emit(option);
        break;

      default:
        this.changeOption.emit(option);
        break;
    }
  }

  isSelectable(path: string): boolean {
    return !this.nonSelectable.includes(path);
  }
  async openPopoverFavorite(event: Event) {
    const popover = await this.modalCtrl.create({
      component: FavoriteComponent,
      componentProps: {
        option: 'favorite',
        isFavorite: true,
        melateS: this.melateS,
        isRetro: this.isRetro,
        sorteoS: this.sorteoS,
        sorteoType: this.sorteoType,
        chispazoS: this.chispazoS,
        trisS: this.trisS,
        ganaGatoS: this.ganaGatoS,
        pronoSportsS: this.pronoSportsS,
      },
    });

    await popover.present();
    // Capturar data al cerrar el modal
    const { data } = await popover.onWillDismiss();
    // data.selectedTickets será el array devuelto
    if (data?.selectedTickets) {
      // Notificamos al padre
      this.applyFavoriteTickets.emit(data.selectedTickets);
    }
  }

  async openPopoverRecommendation(event: Event) {
    let gameLimit = 56;
    let gameSize = 6;
    let isRetro = false;
    let gameType = '';
    let isMediaSemana = false;
    if (this.chispazoS) {
      const wager = await this.chispazoS.getWagerInfo();
      gameLimit = (await this.chispazoS.getDataGameInfo(wager!)).limit;
      gameSize = 7;
      gameType = 'chispazo';
    } else if (this.trisS) {
      gameLimit = this.trisS.limit;
      gameSize = this.trisS.size || 6;
      gameType = 'tris';
    } else if (this.melateS) {
      isRetro = this.isRetro;
      gameLimit = this.melateS.getLimit(isRetro);
      gameSize = 10;
      gameType = 'melate';
    } else if (this.ganaGatoS) {
      gameLimit = 5;
      gameSize = 8;
      gameType = 'gana-gato';
    } else if (this.sorteoS) {
      gameLimit = 5;
      gameSize = this.sorteoS.getSize(this.sorteoType!);
      gameType = this.sorteoType!;
    } else if (this.protouchS) {
      gameLimit = 5;
      gameSize = 39;
      gameType = 'protouch';
    } else if (this.progolS) {
      gameLimit = 21;
      gameSize = 63;
      gameType = 'progol';
      isMediaSemana = this.isMediaSemana;
    }

    const popover = await this.modalCtrl.create({
      component: RecommendationComponent,
      componentProps: {
        limit: gameLimit,
        size: gameSize,
        gameType: gameType,
        sorteoType: this.sorteoType,
        sorteoS: this.sorteoS,
        isRetro: this.isRetro,
        isMediaSemana: this.isMediaSemana,
      },
    });

    await popover.present();

    const { data } = await popover.onWillDismiss();
    if (data) {
      if (this.gameType === 'protouch') {
        this.applyRecommendedProtouch.emit(data);
      } else if (this.gameType === 'progol' && data.isMediaSemana) {
        this.applyRecommendedProgolMS.emit(data);
      } else if (this.gameType === 'progol' && !data.isMediaSemana) {
        this.applyRecommendedProgolRev.emit(data);
      } else {
        this.applyRecommendedNumbers.emit(data);
      }
    }
  }
}
